/**
 * URL endpoint of the Stackdriver Error Reporting report API.
 */
const baseAPIUrl =
    'https://clouderrorreporting.googleapis.com/v1beta1/projects/';
const ReadyState = {
    UNSENT: 0,
    OPENED: 1,
    HEADERS_RECEIVED: 2,
    LOADING: 3,
    DONE: 4
};

const report = (reportUrl, serviceContext, message) => {
    var xhr = new XMLHttpRequest();
    xhr.open('POST', reportUrl, true);
    xhr.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');

    const context = {
        httpRequest: {
            userAgent: window.navigator.userAgent,
            url: window.location.href
        }
    };

    // See: https://cloud.google.com/error-reporting/reference/rest/v1beta1/ErrorEvent
    var payload = {
        serviceContext,
        context,
        message
    };

    return new Promise(function(resolve, reject) {
        xhr.onreadystatechange = () => {
            if (xhr.readyState === ReadyState.DONE) {
                var code = xhr.status;
                if (code >= 200 && code < 300) {
                    resolve({ message: payload.message });
                } else {
                    var condition = code
                        ? code + ' http response'
                        : 'network error';
                    reject(new Error(condition + ' on stackdriver report'));
                }
            }
        };
        xhr.send(JSON.stringify(payload));
    });
};

export const createReporter = config => {
    if (!config.apiKey) {
        throw new Error('Cannot initialize: No API key');
    }
    if (!config.projectId) {
        throw new Error('Cannot initialize: No project ID');
    }

    const reportUrl = `${baseAPIUrl}${config.projectId}/events:report?key=${
        config.apiKey
    }`;

    const serviceContext = {
        service: 'TouchWeb',
        version: window.releaseVersion
    };

    return message => report(reportUrl, serviceContext, message);
};
